module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0124.jpg?v=400e5e15";